// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__KVvOi","obliqueLineWrap":"membershipbadge_obliqueLineWrap__33lbq","obliqueLine":"membershipbadge_obliqueLine__2ITQ-"};